import { IMPORT_GROUPS } from 'constants/actionTypes';

export function importGroups(data, mapping) {
  return {
    type: IMPORT_GROUPS,
    data,
    mapping,
  };
}
